<script>
  import { duplicateIcon } from "../../../Utils/utilConstants.svelte";
  import { copyObjContent } from "../../../Utils/utilFunctions.svelte";
  import { CardLayout } from "../index.svelte";

  export let response = "";

  let isResponseInJson;

  $: if (response) {
    try {
      JSON.parse(response);
      isResponseInJson = true;
    } catch (err) {
      isResponseInJson = false;
    }
  }

  $: btnOptions = [
    {
      iconName: "copyIcon",
      iFont: duplicateIcon,
      hasTooltip: true,
      tooltip: "Copy content",
      iconFunction: () =>
        copyObjContent(
          isResponseInJson ? JSON.parse(response) : response,
          "Response Copied!",
        ),
      isHidden: !response,
    },
  ];
</script>

<CardLayout title="Response" {btnOptions}>
  <div class="flex flex-col p-2 w-full gap-y-3">
    <div class="flex flex-row gap-x-2">
      {#if response}
        {#if isResponseInJson}
          <pre class="whitespace-pre-wrap font-sans break-all">{JSON.stringify(
              JSON.parse(response),
              undefined,
              2,
            )}</pre>
        {:else}
          <p class="whitespace-pre-wrap break-all font-sans">
            {response}
          </p>
        {/if}
      {:else}
        <p>No response</p>
      {/if}
    </div>
  </div>
</CardLayout>
